import React from 'react';
import { GoogleLogin } from 'react-google-login';

const GoogleLoginComponent = ({ onSuccess, onFailure }) => {
  const responseGoogle = (response) => {
    if (response && response.profileObj) {
      // Handle the user data, e.g., send it to your server
      onSuccess(response.profileObj);
    } else {
      onFailure(response.error);
    }
  };

  return (
    <GoogleLogin
      clientId="225363696010-5joicf0mfl631lta0t9cl7k0b3ddqqou.apps.googleusercontent.com"
      buttonText="Login with Google"
      onSuccess={responseGoogle}
      onFailure={responseGoogle}
    />
  );
};

export default GoogleLoginComponent;
